// frontend/src/design-system/components/ErrorState.tsx
import * as React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../../components/ui/button';

interface Props {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

export function ErrorState({ title = 'Something went wrong', description, onRetry }: Props) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6">
      <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-destructive/10 ring-1 ring-destructive/20 text-destructive">
        <AlertTriangle className="h-5 w-5" />
      </div>
      <h3 className="font-serif text-2xl tracking-tight text-foreground text-balance">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mt-2 max-w-md whitespace-pre-wrap leading-relaxed">{description}</p>}
      {onRetry && <Button variant="outline" className="mt-6" onClick={onRetry}>Try again</Button>}
    </div>
  );
}
